import dummyAvatar from '@common/react/images/avatar.jpg';

interface WithAvatar {
	avatar: string;
}

export const getAvatar: (user: WithAvatar | null, dummyImage?: string) => string = (user, dummyImage) => {
	return `${(user && user.avatar) ? user.avatar : dummyImage || dummyAvatar}`;
};
